import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  dialog:{
    borderRadius: '5px!important',
    width: '525px',
  },
  dialogTitle:{
    color: '#18477D',
    paddingLeft: '24px!important',
  },
  dialogContentText:{
    color: '#757575!important'
  },
  dialogActions:{
    padding: '25px !important',
  },
  dialogActionsWithBoldText:{
    padding: '0px 25px 25px 25px !important'
  },
  dialogButtonNo:{
    padding: '8px 16px 6px 16px!important',
    color: '#18477D!important',
    borderColor: '#18477D!important',
    borderRadius: '5px!important',
    textTransform: 'none',
  },
  dialogButtonYes:{
    padding: '8px 16px 6px 16px!important',
    color: '#FFFFFF!important',
    backgroundColor: '#18477D!important',
    borderColor: '#18477D!important',
    borderRadius: '5px!important',
    textTransform: 'none',
    marginLeft: '15px!important',
  },
  boldText:{
    paddingTop: 15,
  }
}));
